module.exports = {
  xs: 360,
  sm: 480,
  md: 760,
  lg: 1040,
  xl: 1320,
};
